// src/Components/PolaroidGallery/PolaroidGallery.jsx
import React from 'react';
import './PolaroidGallery.css';
import { IMAGES } from '../../config/supabaseImages';
import { getSiteAsset, useSiteAssets } from '../../utils/useSiteAssets';

const PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600"><rect width="100%" height="100%" fill="#f3f4f6"/><text x="50%" y="50%" fill="#9ca3af" font-family="Arial, sans-serif" font-size="20" dominant-baseline="middle" text-anchor="middle">Imagen no disponible</text></svg>`
  );

const PolaroidGallery = () => {
  const assets = useSiteAssets();

  const photos = [
    {
      src: getSiteAsset(assets, 'polaroid.1') || IMAGES?.gallery?.avioneta,
      alt: assets['polaroid.1']?.alt || 'Sesión en avioneta',
      className: 'pol__photo--1',
    },
    {
      src: getSiteAsset(assets, 'polaroid.2') || IMAGES?.gallery?.nieve,
      alt: assets['polaroid.2']?.alt || 'Sesión de quince en la nieve',
      className: 'pol__photo--2',
    },
    {
      src: getSiteAsset(assets, 'polaroid.3') || IMAGES?.gallery?.auriculares,
      alt: assets['polaroid.3']?.alt || 'Detalle de auriculares',
      className: 'pol__photo--3',
    },
  ].filter((photo) => photo.src);

  const handleImgError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = PLACEHOLDER;
    e.currentTarget.alt = 'Imagen no disponible';
  };

  return (
    <section className="pol">
      <div className="pol__top-line" aria-hidden="true" />
      <div className="pol__inner">
        {photos.map(({ src, alt, className }) => (
          <div className={`pol__frame ${className}`} key={className}>
            <img src={src} alt={alt} className="pol__img" onError={handleImgError} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PolaroidGallery;
